<template>
  <div>
    <Row type="flex" justify="space-between" align="middle" class="code-row-bg">
      <Col span="2">
      {{ invoiceDue.invoicedate | showDateFormatted }}
      </Col>

      <Col span="6">
      {{ invoiceDue.description }}
      </Col>

      <Col span="3" class="brweb-flex">
      <div align="right">
        {{ invoiceDue.invoicefee | currency }}
        <span v-show="invoiceDue.invoicefeeIdr > 0">({{ invoiceDue.invoicefeeIdr | currencyIdr }})</span>
      </div>

      <div>
        <Tooltip v-show="invoiceDue.receivableDebitAmount != invoiceDue.invoicefee" placement="top">

          <Icon type="ios-help-outline"></Icon>
          <div slot="content">
            <template>
              Invoice Awal : {{ invoiceDue.receivableDebitAmount | currency }}
            </template>
          </div>
        </Tooltip>
      </div>
      </Col>

      <Col span="3" class="brweb-flex">
      <template v-if="invoiceDue.invoicefee == invoiceDue.receivableRemaining">
        <div align="right">
          {{ invoiceDue.receivableRemaining | currency }}
          <span v-show="invoiceDue.receivableRemainingIdr > 0">({{ invoiceDue.receivableRemainingIdr | currencyIdr
            }})</span>

        </div>
      </template>

      <template v-else>
        <div align="right" style="color: red;">
          {{ invoiceDue.receivableRemaining | currency }}
          <span v-show="invoiceDue.receivableRemainingIdr > 0">({{ invoiceDue.receivableRemainingIdr | currencyIdr
            }})</span>
        </div>
      </template>

      <div>
        <Tooltip v-show="invoiceDue.receivableRemaining != invoiceDue.invoicefee" placement="top">

          <Icon type="ios-help-outline"></Icon>
          <div slot="content">
            <!-- Total Bayar : {{ invoiceDue.receivableRemaining  | currency}} -->
            Total Bayar : {{ invoiceDue.paymentSum | currency }}
          </div>
        </Tooltip>
      </div>
      </Col>

      <template v-if="paymentPendingId == null">
        <Col span="3">
        <money v-model="allocateAmount" v-bind="money" class="ivu-input ivu-input-small"></money>
        <div v-show="depositRemaining > 0" style="margin-top:10px;">
          Deposit <money v-model="useDepositAmount" v-bind="money" class="ivu-input ivu-input-small"></money>
        </div>
        <div v-show="depositMutasiRemaining > 0" style="margin-top:10px;">
          Deposit Mutasi <money v-model="useDepositMutasi" v-bind="money" class="ivu-input ivu-input-small"
            style="width : 120px">
          </money>
        </div>
        </Col>

      </template>

      <template v-if="paymentPendingId">
        <Col span="3">
        <money v-model="allocateAmount" v-bind="money" class="ivu-input ivu-input-small"></money>
        <div v-show="depositRemaining > 0" style="margin-top:10px;">
          Deposit <money v-model="useDepositAmount" v-bind="money" class="ivu-input ivu-input-small"></money>
        </div>
        </Col>
      </template>

      <Col span="3">
      <div>
        <div v-if="paymentPendingId">
          <money v-model="discountAmount" @input="maximalDiscount" v-bind="money" class="ivu-input ivu-input-small">
          </money>
        </div>
      </div>
      <div style="margin-top: 10px;">
        <div>
          <div v-if="paymentPendingId">
            <span style="font-size: 12px">Keterangan Potongan</span><Input v-model="discountDescription"
              placeholder=". . . " size="small"></Input>
          </div>
        </div>
      </div>
      <div v-show="depositMutasiRemaining > 0" style="margin-top:10px;">
          Deposit Mutasi <money v-model="useDepositMutasi" v-bind="money" class="ivu-input ivu-input-small"
            style="width : 120px">
          </money>
        </div>
        </Col>
        <!-- <Col span="1">
          <div>
            <div >
              <Button-group size="small" >
                <Button type="success" @click="toggleAllocateAll()" >All</Button>
              </Button-group>
            </div>
        </div>
      </Col> -->
      <Col span="1">
      <div>
        <div>
          <Button-group size="small">
            <Button type="success" @click="toggleAllocateAll()">All</Button>
          </Button-group>
        </div>
      </div>
      </Col>

    </Row>
    <Row>
      <Col span="24">
      <br />
      <hr />
      </Col>
    </Row>
  </div>
</template>

<script>
import { Money } from 'v-money'
const numeral = require('numeral');
import moment from 'moment'


export default {
  props: {
    invoiceDue: Object,
    depositRemaining: Number,
    depositMutasiRemaining: Number,
    paymentPendingId: Number,
    paymentPendingAmount: Number,
  },
  data: () => ({
    allocateAmount: 0.00,
    useDepositAmount: 0.00,
    useDepositMutasi: 0.00,
    discountAmount: 0.00,
    discountDescription: '',
    money: {
      decimal: '.',
      thousands: ',',
      prefix: '',
      suffix: '',
      precision: 2,
      masked: false
    }
  }),
  components: { Money },
  methods: {
    toggleAllocateAll: function () {
      let receivableRemaining =
        this.invoiceDue.receivableRemaining - (this.allocateAmount + this.useDepositAmount + this.useDepositMutasi)

        console.log(receivableRemaining);


      this.allocateAmount += receivableRemaining;
    },
    emitAllAmount: function () {
      // this.toggleAllocateAll();
      this.$emit('setAllocateAmount', this.invoiceDue)
    },
    distributePayment: function () {
      if (this.invoiceDue.pendingAmount > 0) {
        this.allocateAmount = this.invoiceDue.pendingAmount;
      }
    },
    maximalDiscount: function () {
      if (this.discountAmount > this.invoiceDue.receivableRemaining) {
        this.discountAmount = this.invoiceDue.receivableRemaining;
      }
      this.$forceUpdate();
    }
  },
  mounted() {
    this.distributePayment();
  },
  watch: {
    allocateAmount: function (newAllocateAmount) {
      this.invoiceDue.allocateAmount = parseFloat(this.allocateAmount) || 0;
      let amount = this.allocateAmount + this.discountAmount;

      if (amount > this.invoiceDue.receivableRemaining) {
        this.discountAmount = 0
      }
      console.log(amount)

      this.emitAllAmount();
    },
    discountAmount: function (newDiscountAmount) {
      this.invoiceDue.discountAmount = parseFloat(this.discountAmount) || 0;
      let amount = this.allocateAmount + this.discountAmount;

      if (amount > this.invoiceDue.receivableRemaining) {
        this.allocateAmount = (this.allocateAmount - this.discountAmount) + (this.invoiceDue.receivableRemaining - this.allocateAmount)
      }
      this.emitAllAmount();
    },
    discountDescription: function () {
      this.invoiceDue.discountDescription = this.discountDescription;
      this.emitAllAmount();
    },
    useDepositAmount: function () {
      this.invoiceDue.useDepositAmount = parseFloat(this.useDepositAmount) || 0;
      this.emitAllAmount();
    },
    useDepositMutasi: function () {
        this.invoiceDue.useDepositMutasi = parseFloat(this.useDepositMutasi) || 0;
        this.emitAllAmount();
    }
  },

  filters: {
    currency: function (value) {
      if (!value) return ''
      return numeral(value).format('0,0.00')
    },
    currencyIdr: function (value) {
      if (!value) return ''
      return numeral(value).format('0,0')
    },
    showDateFormatted: function (stringToFormat) {
      let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
      return moment(dateToFormat).format("DD MMM YYYY")
    }
  }
}

</script>

<style>
.ivu-input {
  /* height: 24px; */
}

div.brweb-flex {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// cInvoicePaymentDecimal.vue?d4bf553c